import { CdkStepper, StepperSelectionEvent } from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FULL_DATE_PATTERN, ID_SECOND_IDENTICATION_GROUP_DOCUMENT, incomeOrigins, nameOfDocumentToTakePictureOnCreditRequests, otherIncomeTypes, PARAM_SHORTFORMCREDITPLANCODES, ParamListOfBranchesNotValidateBiometryOnCreditRequest, Personality } from 'src/app/@core/constants';
import { CreditRequestUtils } from 'src/app/@core/utils/credit-request-utils';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { FileUtils } from 'src/app/@core/utils/file-utils';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { PosValidators } from 'src/app/@core/validators/pos-validators';
import { CreditReferenceList } from 'src/app/models/credit-reference-list';
import { CreditRequest } from 'src/app/models/credit-request';
import { CreditRequestData } from 'src/app/models/credit-request-data';
import { Customer } from 'src/app/models/customer';
import { CustomerInfoFromSAP } from 'src/app/models/customer-info-from-sap';
import { FiscalIdTypes } from 'src/app/models/fiscalIdTypes';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseDoc } from 'src/app/models/onbase-doc';
import { ResponseModel } from 'src/app/models/response-model';
import { BiometryLog } from 'src/app/models/response/biometrylogResponse';
import { CreditStatusFranchisedResponseModel } from 'src/app/models/response/customerCreditStatusResponseModel';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { BiometryService } from 'src/app/services/biometry.service';
import { CityService } from 'src/app/services/city.service';
import { ColonyService } from 'src/app/services/colony.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CreditService } from 'src/app/services/credit.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { FiscalIdService } from 'src/app/services/fiscal-id.service';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ParamsService } from 'src/app/services/params.service';
import { RegionService } from 'src/app/services/region.service';
import Swal from 'sweetalert2';
import { CreditRequestSaveStepComponent } from '../credit-request-save-step/credit-request-save-step.component';

@Component({
  selector: 'app-person-guaranteed-plan-stepper',
  templateUrl: './person-guaranteed-plan-stepper.component.html',
  styleUrls: ['./person-guaranteed-plan-stepper.component.sass']
})
export class PersonGuaranteedPlanStepperComponent implements OnInit {
  @ViewChild('saveStepComponent') saveStepComponent!: CreditRequestSaveStepComponent;
  @ViewChild('cdkStepper') stepper!: CdkStepper;
  generalnformationForm: FormGroup = new FormGroup({});
  bankRepresentativeForm: FormGroup = new FormGroup({});
  personInformationForm: FormGroup = new FormGroup({});
  personAddressInformationForm: FormGroup = new FormGroup({});
  personIncomeInformationForm: FormGroup = new FormGroup({});
  personReferencesInformationform: FormArray = new FormArray([]);
  observationForm: FormGroup = new FormGroup({});
  documentsForm: FormArray = new FormArray([]);
  biometryForm: FormGroup = new FormGroup({});

  creditPlan: OnbaseProcedureResponseModel = new OnbaseProcedureResponseModel();
  customerCreditConditions: CreditStatusFranchisedResponseModel = new CreditStatusFranchisedResponseModel();
  customer: Customer = new Customer();
  customerInfoFromSAP: CustomerInfoFromSAP = new CustomerInfoFromSAP();
  seller: any;
  onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  onbaseDocs: Array<OnbaseDoc> = [];
  fiscalIdTypes: Array<FiscalIdTypes> = [];
  nationalities: Nationality[] = [];
  request: CreditRequest = new CreditRequest();
  isDraft: boolean = false;
  selectedIndex: number = 0;
  listOfBranchesNotValidateBiometry = "";
  shortFormCreditPlanCodes = "";
  pictureUrlString = "";
  requestType: `AVAL` | `CUSTOMER` | string = `CUSTOMER`;
  biometryLog: BiometryLog = {};
  constructor(private fb: FormBuilder,
    private router: Router,
    private onbaseService: OnbaseService,
    private fiscalIdTypeService: FiscalIdService,
    private configService: ConfigurationService,
    private nationalityService: NationalityService,
    private regionService: RegionService,
    private cityService: CityService,
    private colonyService: ColonyService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private creditService: CreditService,
    private paramService: ParamsService,
    private biometryService: BiometryService,
    private readonly exceptionSolutionService: ExceptionSolutionService) {
    if (!this.router.getCurrentNavigation()?.extras.state) {
      this.router.navigate(["creditRequests"]);
    }
    this.creditPlan = this.router.getCurrentNavigation()?.extras.state?.creditPlan as OnbaseProcedureResponseModel || new OnbaseProcedureResponseModel();
    this.customerCreditConditions = this.router.getCurrentNavigation()?.extras.state?.customerCreditConditions as CreditStatusFranchisedResponseModel || new CreditStatusFranchisedResponseModel();
    this.customer = this.router.getCurrentNavigation()?.extras.state?.customer as Customer || new Customer();
    this.seller = this.router.getCurrentNavigation()?.extras.state?.seller;
    if (this.router.getCurrentNavigation()?.extras.state?.isDraft) {
      this.request = this.router.getCurrentNavigation()?.extras.state?.request;
      this.isDraft = true;
    }

    this.configureForms();
  }

  async ngOnInit(): Promise<void> {
    this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    this.fiscalIdTypes = (await this.fiscalIdTypeService.readFiscalIds().toPromise()).response;
    this.onbaseDocs = (await this.onbaseService.readOnBaseDocs().toPromise()).response;
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    this.customerInfoFromSAP = (await this.creditService.readCustomerFromSAP(this.customer.code, this.customer.mainPersonalInfo?.nationality || "").toPromise());
    this.listOfBranchesNotValidateBiometry = (await this.paramService.readParam(ParamListOfBranchesNotValidateBiometryOnCreditRequest).toPromise()).response.value;
    this.shortFormCreditPlanCodes = (await this.paramService.readParam(PARAM_SHORTFORMCREDITPLANCODES).toPromise()).response.value;

    if (!this.isDraft) {
      this.configureForms();
    }
    else {
      await this.configureFormsFromRequest();
    }
  }
  async configureFormsFromRequest() {
    this.configureGeneralFormFromRequest();
    this.configureBankRepresentativeFormFromRequest();
    this.configurePersonInformationFormFromRequest();
    this.configPersonAddressInformationFormFromRequest();
    this.configPersonIncomeInformationFormFromRequest();
    this.configPersonReferencesInformationFormFromRequest();
    this.configureObservationsFormFromRequest();
    await this.configureDocumentsFormFromRequest();
    await this.configureBiometryFormFromRequest();
  }

  configureBankRepresentativeFormFromRequest() {
    this.bankRepresentativeForm = this.fb.group({
      mainRequestCode: new FormControl(this.request.requestData.Codigo_Solicitud_Principal)
    })
  }

  configPersonReferencesInformationFormFromRequest() {
    this.request.requestData.ListaReferencias.forEach(m => {
      let f = new FormGroup({
        firstName: new FormControl(m.DR_Primer_Nombre, Validators.required),
        middleName: new FormControl(m.DR_Segundo_Nombre),
        lastName: new FormControl(m.DR_Primer_Apellido, Validators.required),
        secondLastName: new FormControl(m.DR_Segundo_Apellido),
        familyRelationship: new FormControl(m.DR_Parentesco, Validators.required),
        mobilePhone: new FormControl(m.DR_Celular, Validators.required),
        phone: new FormControl(m.DR_Telefono),
        workPhone: new FormControl(m.DR_Telefono_Trabajo),
        workPhoneExtension: new FormControl(m.DR_Telefono_Trabajo_Extension),
      })
      this.personReferencesInformationform.push(f);
    })
  }

  configureGeneralFormFromRequest() {
    this.generalnformationForm = this.fb.group({
      personality: new FormControl(this.customer.mainPersonalInfo?.personality),
      personalityDescription: new FormControl(CreditRequestUtils.getPersonalityDescription(this.customer.mainPersonalInfo?.personality || "")),
      requestType: new FormControl(this.request.requestData.Tipo_Solicitante),
      creditPlan: new FormControl(this.creditPlan.code),
      creditPlanDescription: new FormControl(this.creditPlan.name),
      sellerCode: new FormControl(this.seller?.code || this.seller?.username || ""),
      sellerName: new FormControl(this.seller?.fullName || this.seller?.fullname || "")

    });

    this.requestType = this.request.requestData.Tipo_Solicitante;

    this.configureGeneralFormFields();
    this.generalnformationForm.markAsTouched();
  }

  configurePersonInformationFormFromRequest() {
    this.personInformationForm = this.fb.group({
      names: new FormControl(this.customer.mainPersonalInfo?.name),
      lastNames: new FormControl(this.customer.mainPersonalInfo?.lastName),
      fiscalId: new FormControl(this.customer.mainPersonalInfo?.fiscalId),
      fiscalIdName: new FormControl(this.fiscalIdTypes.find(f => f.code == this.customer.mainPersonalInfo?.fiscalIdType)?.name),
      fiscalIdType: new FormControl(this.customer.mainPersonalInfo?.fiscalIdType),
      nationality: new FormControl(this.customer.mainPersonalInfo?.nationality),
      sex: new FormControl(CreditRequestUtils.getSex(this.customer.mainPersonalInfo?.gender || "I")),
      birthDate: new FormControl(new Date(this.request.requestData.Fecha_Nacimiento), Validators.required),
      age: new FormControl(CreditRequestUtils.getAge(new Date(this.request.requestData.Fecha_Nacimiento))),
      civilStatus: new FormControl(this.request.requestData.Estado_Civil, Validators.required),
      dependentsAmount: new FormControl(this.request.requestData.Numero_Dependientes, [Validators.required, Validators.min(0)]),
      email: new FormControl(this.request.requestData.Correo_Electronico, Validators.email),
      vehicle: new FormControl(this.request.requestData.Vehiculo == "SI", Validators.required),
      ocupation: new FormControl(this.request.requestData.Ocupacion, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
      academicTitle: new FormControl(this.request.requestData.Titulo_Academico, this.isShortFormActiveForPlan() ? [] : [Validators.required])
    })
    this.configurePersonInformationFormFields();
  }

  configPersonAddressInformationFormFromRequest() {
    this.personAddressInformationForm = this.fb.group({
      homeType: new FormControl(this.request.requestData.Tipo_Vivienda, Validators.required),
      liveFromDate: new FormControl(this.request.requestData.Vive_Desde ? new Date(this.request.requestData.Vive_Desde) : "", this.isShortFormActiveForPlan() ? [] : [Validators.required]),
      country: new FormControl(this.request.requestData.Pais, Validators.required),
      deparment: new FormControl(this.request.requestData.Departamento, Validators.required),
      city: new FormControl(this.request.requestData.Ciudad_Municipio, Validators.required),
      street: new FormControl(this.request.requestData.Calle1, Validators.required),
      street2: new FormControl(this.request.requestData.Calle2),
      street3: new FormControl(this.request.requestData.Calle3),
      street4: new FormControl(this.request.requestData.Calle4),
      street5: new FormControl(this.request.requestData.Calle5),
      neighborhood: new FormControl(this.request.requestData.Aldea_Barrio_Caserio_Colonia, Validators.required),
      mobilePhone: new FormControl(this.request.requestData.Celular, Validators.required),
      phone: new FormControl(this.request.requestData.Telefono)
    })

    this.configPersonAddressInformationFormFields();
  }

  configPersonIncomeInformationFormFromRequest() {
    this.personIncomeInformationForm = this.fb.group({
      incomeType: new FormControl(this.request.requestData.Fuente_Ingreso, Validators.required),
      incomeForm: new FormGroup({})
    });

    this.configPersonIncomeInformationIncomeFormFromRequest(this.request.requestData.Fuente_Ingreso)
    this.personIncomeInformationForm.markAsTouched();
  }
  configPersonIncomeInformationIncomeFormFromRequest(incomeType: string): any {
    switch (incomeType) {
      case 'Z000':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          companyType: new FormControl(this.request.requestData.Tipo_Empresa, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
          companyName: new FormControl(this.request.requestData.Nombre_Lugar_Trabajo, Validators.required),
          monthlySalaryAmount: new FormControl(this.request.requestData.Salario_Mensual, [Validators.min(1), Validators.required]),
          startDate: new FormControl(this.request.requestData.Fecha_Ingreso_Empresa ? new Date(this.request.requestData.Fecha_Ingreso_Empresa) : "", Validators.required),
          workContractType: new FormControl(this.request.requestData.Tipo_Contrato, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
          workDepartmentName: new FormControl(this.request.requestData.Departamento_Labora, Validators.required),
          workPosition: new FormControl(this.request.requestData.Cargo, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
          country: new FormControl(this.request.requestData.Pais_Trabajo, Validators.required),
          deparment: new FormControl(this.request.requestData.Departamento_Empresa, Validators.required),
          city: new FormControl(this.request.requestData.Ciudad_Municipio_Empresa, Validators.required),
          neighborhood: new FormControl(this.request.requestData.Aldea_Barrio_Caserio_Colonia_Empresa, Validators.required),
          street: new FormControl(this.request.requestData.Calle1_Empresa, Validators.required),
          street2: new FormControl(this.request.requestData.Calle2_Empresa),
          street3: new FormControl(this.request.requestData.Calle3_Empresa),
          street4: new FormControl(this.request.requestData.Calle4_Empresa),
          street5: new FormControl(this.request.requestData.Calle5_Empresa),
          companyPhone: new FormControl(this.request.requestData.Telefono_Empresa, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
          companyExtension: new FormControl(this.request.requestData.Extension_Telefono_Empresa),
        }));

        break;
      case 'Z001':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          businessName: new FormControl(this.request.requestData.Nombre_Negocio, this.isShortFormActiveForPlan() ? [] : [Validators.required]),
          incomeAmount: new FormControl(this.request.requestData.Ingreso, [Validators.min(1), Validators.required]),
          economicActivity: new FormControl(this.request.requestData.Actividad_Economica, Validators.required),
          businessRelationType: new FormControl(this.request.requestData.Relacion_Empresa, Validators.required),
          businessRelationDate: new FormControl(this.request.requestData.Fecha_Ingreso_Empresa ? new Date(this.request.requestData.Fecha_Ingreso_Empresa) : "", Validators.required),
          country: new FormControl(this.request.requestData.Pais_Trabajo, Validators.required),
          deparment: new FormControl(this.request.requestData.Departamento_Empresa, Validators.required),
          city: new FormControl(this.request.requestData.Ciudad_Municipio_Empresa, Validators.required),
          neighborhood: new FormControl(this.request.requestData.Aldea_Barrio_Caserio_Colonia_Empresa, Validators.required),
          street: new FormControl(this.request.requestData.Calle1_Empresa, Validators.required),
          street2: new FormControl(this.request.requestData.Calle2_Empresa),
          street3: new FormControl(this.request.requestData.Calle3_Empresa),
          street4: new FormControl(this.request.requestData.Calle4_Empresa),
          street5: new FormControl(this.request.requestData.Calle5_Empresa),
          companyPhone: new FormControl(this.request.requestData.Telefono_Empresa, Validators.required),
          companyExtension: new FormControl(this.request.requestData.Extension_Telefono_Empresa),
        }));
        break;
      case 'Z002':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          incomeAmount: new FormControl(this.request.requestData.Ingreso, this.isShortFormActiveForPlan() ? [Validators.min(0)] : [Validators.min(1), Validators.required]),
          remittanceName: new FormControl(this.request.requestData.Nombre_Remitente, Validators.required),
          familyRelationship: new FormControl(this.request.requestData.Parentesco, Validators.required),
          incomeOrigin: new FormControl(this.request.requestData.Procedencia, Validators.required),
          receivingDate: new FormControl(this.request.requestData.Fecha_Ingreso_Empresa ? new Date(this.request.requestData.Fecha_Ingreso_Empresa) : "", this.isShortFormActiveForPlan() ? [] : [Validators.required]),
        }))
        break;
      case 'Z005':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          incomeType: new FormControl(this.request.requestData.Tipo_Ingreso, Validators.required),
          incomeAmount: new FormControl(this.request.requestData.Ingreso, [Validators.min(1), Validators.required]),
          specify: new FormControl(this.request.requestData.Especifique, Validators.required),
          receivingDate: new FormControl(this.request.requestData.Fecha_Ingreso_Empresa ? new Date(this.request.requestData.Fecha_Ingreso_Empresa) : "", Validators.required),
        }))
        break;
      default:
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({}));
        break;
    }
  }

  configureObservationsFormFromRequest() {
    this.observationForm = this.fb.group({
      observationText: new FormControl(this.request.requestData.Observaciones_Ventas)
    })
    this.observationForm.markAsTouched();
  }

  async configureDocumentsFormFromRequest() {
    this.configureDocumentsForm();
    let files = (await this.onbaseService.listFilesDraft(this.request.code).toPromise());
    if (files && files.response.documents) {
      files.response.documents.forEach(f => {
        let form = this.documentsForm.controls.find(x => x.value.id == f.documentType) as FormGroup;

        let formArray = form.get("documents") as FormArray;

        if (f.documentList === nameOfDocumentToTakePictureOnCreditRequests) {
          if (f.file) {
            this.pictureUrlString = f.file;
          }
        }

        formArray.at(parseInt(f.id)).patchValue({
          [`document_${f.documentType}_${f.id}`]: FileUtils.dataURLtoBlob(f.file),
          [`document_documentType_${f.documentType}_${f.id}`]: f.fileType,
          [`document_ext_${f.documentType}_${f.id}`]: f.extentionFile,
          [`document_fileName_${f.documentType}_${f.id}`]: f.fileName
        })
      })
    }
  }

  configureForms() {
    this.configureGeneralForm();
    this.configureBankRepresentativeForm();
    this.configurePersonInformationForm();
    this.configPersonAddressInformationForm();
    this.configPersonIncomeInformationForm();
    this.personReferencesInformationform.setValidators(Validators.required);
    this.personReferencesInformationform.markAsTouched();
    this.configureObservationsForm();
    this.configureDocumentsForm();
    this.configureBiometryForm();
  }

  configureBankRepresentativeForm() {
    this.bankRepresentativeForm = this.fb.group({
      mainRequestCode: new FormControl("")
    });
  }

  configPersonIncomeInformationForm() {
    this.personIncomeInformationForm = this.fb.group({
      incomeType: new FormControl("", Validators.required),
      incomeForm: new FormGroup({}, Validators.required)
    })

    this.personIncomeInformationForm.get("incomeType")?.markAsDirty();
  }

  configPersonAddressInformationForm() {
    this.personAddressInformationForm = this.fb.group({
      homeType: new FormControl("", Validators.required),
      liveFromDate: new FormControl("", this.isShortFormActiveForPlan() ? [] : [Validators.required]),
      country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
      deparment: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
      neighborhood: new FormControl("", Validators.required),
      street: new FormControl("", Validators.required),
      street2: new FormControl(""),
      street3: new FormControl(""),
      street4: new FormControl(""),
      street5: new FormControl(""),
      mobilePhone: new FormControl("", Validators.required),
      phone: new FormControl("")
    })

    this.configPersonAddressInformationFormFields();
  }
  configPersonAddressInformationFormFields() {
    this.personAddressInformationForm.get("homeType")?.markAsDirty();
    this.personAddressInformationForm.get("homeType")?.enable();
    this.personAddressInformationForm.get("liveFromDate")?.markAsDirty();
    this.personAddressInformationForm.get("liveFromDate")?.enable();
    this.personAddressInformationForm.get("country")?.markAsDirty();
    this.personAddressInformationForm.get("country")?.enable();
    this.personAddressInformationForm.get("deparment")?.markAsDirty();
    this.personAddressInformationForm.get("deparment")?.enable();
    this.personAddressInformationForm.get("city")?.markAsDirty();
    this.personAddressInformationForm.get("city")?.enable();
    this.personAddressInformationForm.get("neighborhood")?.markAsDirty();
    this.personAddressInformationForm.get("neighborhood")?.enable();
    this.personAddressInformationForm.get("street")?.markAsDirty();
    this.personAddressInformationForm.get("street")?.enable();
    this.personAddressInformationForm.get("street2")?.enable();
    this.personAddressInformationForm.get("street3")?.enable();
    this.personAddressInformationForm.get("street4")?.enable();
    this.personAddressInformationForm.get("street5")?.enable();
    this.personAddressInformationForm.get("mobilePhone")?.markAsDirty();
    this.personAddressInformationForm.get("mobilePhone")?.enable();
    this.personAddressInformationForm.get("phone")?.markAsDirty();
    this.personAddressInformationForm.get("phone")?.enable();
  }

  configurePersonInformationForm() {
    this.personInformationForm = this.fb.group({
      names: new FormControl(this.customer.mainPersonalInfo?.name),
      lastNames: new FormControl(this.customer.mainPersonalInfo?.lastName),
      fiscalId: new FormControl(this.customer.mainPersonalInfo?.fiscalId),
      fiscalIdName: new FormControl(this.fiscalIdTypes.find(f => f.code == this.customer.mainPersonalInfo?.fiscalIdType)?.name),
      fiscalIdType: new FormControl(this.customer.mainPersonalInfo?.fiscalIdType),
      nationality: new FormControl(this.customer.mainPersonalInfo?.nationality),
      sex: new FormControl(CreditRequestUtils.getSex(this.customer.mainPersonalInfo?.gender || "I")),
      birthDate: new FormControl(DateUtils.getDateFromString(this.customer.mainPersonalInfo?.birthdate || ""), Validators.required),
      age: new FormControl(CreditRequestUtils.getAge(DateUtils.getDateFromString(this.customer.mainPersonalInfo?.birthdate || ""))),
      civilStatus: new FormControl(this.customer.mainPersonalInfo?.maritalStatus, Validators.required),
      dependentsAmount: new FormControl("0", [Validators.required, Validators.min(0)]),
      email: new FormControl(this.customer.mainPersonalInfo?.email, Validators.email),
      vehicle: new FormControl(false, Validators.required),
      ocupation: new FormControl("", this.isShortFormActiveForPlan() ? [] : [Validators.required]),
      academicTitle: new FormControl("", this.isShortFormActiveForPlan() ? [] : [Validators.required])
    })
    this.configurePersonInformationFormFields();
  }
  configurePersonInformationFormFields() {
    this.personInformationForm.get("names")?.disable({ onlySelf: true });
    this.personInformationForm.get("lastNames")?.disable({ onlySelf: true });
    this.personInformationForm.get("fiscalId")?.disable({ onlySelf: true });
    this.personInformationForm.get("fiscalIdName")?.disable({ onlySelf: true });
    this.personInformationForm.get("fiscalIdType")?.disable({ onlySelf: true });
    this.personInformationForm.get("nationality")?.disable({ onlySelf: true });
    this.personInformationForm.get("sex")?.disable({ onlySelf: true });
    this.personInformationForm.get("age")?.disable({ onlySelf: true });
    this.personInformationForm.get("birthDate")?.enable();
    this.personInformationForm.get("civilStatus")?.enable();
    this.personInformationForm.get("dependentsAmount")?.enable();
    this.personInformationForm.get("email")?.enable();
    this.personInformationForm.get("vehicle")?.enable();
    this.personInformationForm.get("ocupation")?.enable();
    this.personInformationForm.get("academicTitle")?.enable();
    this.personInformationForm.get("civilStatus")?.markAsDirty();
    this.personInformationForm.get("birthDate")?.markAsDirty();
    this.personInformationForm.get("dependentsAmount")?.markAsDirty();
    this.personInformationForm.get("email")?.markAsDirty();
    this.personInformationForm.get("vehicle")?.markAsDirty();
    this.personInformationForm.get("ocupation")?.markAsDirty();
    this.personInformationForm.get("academicTitle")?.markAsDirty();
  }

  configureGeneralForm() {
    this.generalnformationForm = this.fb.group({
      personality: new FormControl(this.customer.mainPersonalInfo?.personality),
      personalityDescription: new FormControl(CreditRequestUtils.getPersonalityDescription(this.customer.mainPersonalInfo?.personality || "")),
      requestType: new FormControl("CUSTOMER", Validators.required),
      creditPlan: new FormControl(this.creditPlan.code),
      creditPlanDescription: new FormControl(this.creditPlan.name),
      sellerCode: new FormControl(this.seller?.code || this.seller?.username || ""),
      sellerName: new FormControl(this.seller?.fullName || this.seller?.fullname || "")

    });

    this.configureGeneralFormFields();
  }

  private configureGeneralFormFields() {
    this.generalnformationForm.get("personality")?.disable({ onlySelf: true });
    this.generalnformationForm.get("personalityDescription")?.disable({ onlySelf: true });
    this.generalnformationForm.get("requestType")?.markAsTouched();
    this.generalnformationForm.get("requestType")?.markAsDirty();
    this.generalnformationForm.get("requestType")?.enable();
    this.generalnformationForm.get("creditPlan")?.disable({ onlySelf: true });
    this.generalnformationForm.get("creditPlanDescription")?.disable({ onlySelf: true });
    this.generalnformationForm.get("sellerCode")?.disable({ onlySelf: true });
    this.generalnformationForm.get("sellerName")?.disable({ onlySelf: true });
  }

  configureObservationsForm() {
    this.observationForm = new FormGroup({
      observationText: new FormControl("")
    });

    this.observationForm.get("observationText")?.markAsDirty()
    this.observationForm.get("observationText")?.enable()
    this.observationForm.markAsTouched();
  }

  configureDocumentsForm() {
    this.documentsForm = new FormArray([]);
    ObjectUtils.objectToArray(this.creditPlan.documents || {}).forEach(m => {

      let arrayOfDocuments = m.value as Array<string>;

      let documents = new FormArray([]);

      arrayOfDocuments.forEach((x, i) => {
        documents.push(new FormGroup({
          [`description_${m.key}_${i.toString()}`]: new FormControl(x),
          [`document_fileName_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_ext_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_documentType_${m.key}_${i.toString()}`]: new FormControl(""),
          [`document_show_take_photo_button_${m.key}_${i.toString()}`]: new FormControl(`${this.canShowBiometryStep() && x == nameOfDocumentToTakePictureOnCreditRequests}`)
        }))
      })
      // let documents = arrayOfDocuments.reduce((a, v) => ({
      //   ...a,
      //   [`description_${m.key}_${arrayOfDocuments.indexOf(v)}`]: new FormControl(v), [`document_fileName_${m.key}_${arrayOfDocuments.indexOf(v)}`]: new FormControl(""), [`document_${m.key}_${arrayOfDocuments.indexOf(v)}`]: new FormControl("")
      // }), {})

      let formToPush = new FormGroup({
        id: new FormControl(m.key),
        description: new FormControl(this.onbaseDocs.find(x => x.code == m.key)?.name),
        documents: documents
      });
      this.documentsForm.push(formToPush);
    })
    this.documentsForm.setValidators(PosValidators.validateDocuments);
    this.documentsForm.markAsTouched();
  }

  private updateValues() {
    this.generalnformationForm.patchValue(this.generalnformationForm.getRawValue());
    this.personInformationForm.patchValue(this.personInformationForm.value);
    this.personAddressInformationForm.patchValue(this.personAddressInformationForm.value);
    this.personIncomeInformationForm.patchValue(this.personIncomeInformationForm.value);
    this.personReferencesInformationform.patchValue(this.personReferencesInformationform.value);
    this.observationForm.patchValue(this.observationForm.value);
    this.documentsForm.patchValue(this.documentsForm.value);
    this.bankRepresentativeForm.patchValue(this.bankRepresentativeForm.value);
  }

  reenableForms() {
    this.configureGeneralFormFields();
    this.configurePersonInformationFormFields();
    this.configPersonAddressInformationFormFields();
    this.personReferencesInformationform.enable();
    this.personIncomeInformationForm.enable();
    this.documentsForm.enable();
    this.observationForm.get("observationText")?.enable();
    this.observationForm.markAsTouched();
    this.bankRepresentativeForm.enable();

  }

  async enableForms(event: StepperSelectionEvent) {
    const indexCondition = this.showRepresentativeStep() ? 9 : 8;
    const biometryIndexStep = this.showRepresentativeStep() ? 8 : 7;
    this.selectedIndex = event.selectedIndex;
    if (event.selectedIndex == indexCondition) {
      this.updateValues();
    }
    else {
      this.reenableForms();
    }

    if (this.canShowBiometryStep()) {
      if (event.selectedIndex == biometryIndexStep) {
        if (this.isSomeFormInvalid()) {
          this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Completa los campos requeridos de la solicitud antes de realizar la biometria`);
          if (this.selectedIndex === this.stepper.steps.length - 1) {
            this.stepper.selectedIndex = event.previouslySelectedIndex;
          }
        }
      } else {
        if (!this.isDraft && this.request.code == '') {
          await this.createDrafRequest();
        }
      }
    }
  }

  getMap() {
    let map = new Map<string, AbstractControl>();
    map.set("generalnformationForm", this.generalnformationForm);
    map.set("bankRepresentativeForm", this.bankRepresentativeForm);
    map.set("personInformationForm", this.personInformationForm);
    map.set("personAddressInformationForm", this.personAddressInformationForm);
    map.set("personIncomeInformationForm", this.personIncomeInformationForm);
    map.set("personReferencesInformationform", this.personReferencesInformationform);
    map.set("observationForm", this.observationForm);
    map.set("documentsForm", this.documentsForm);
    if (this.canShowBiometryStep()) {
      map.set("biometryForm", this.biometryForm);
    }
    return map;
  }

  async createRequest(isDraft: boolean) {
    let requestData = new CreditRequestData();

    await this.buildRequest(requestData, isDraft);
    if (!this.isDraft) {
      (await this.onbaseService.createOnBaseRequest(requestData, isDraft, this.biometryForm.get('biometryLogCode')?.value).toPromise().then(async x => {
        await this.successSendCreditRequest(requestData, x, isDraft);
      }).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Error al querer crear la solicitud ${error}`, undefined, 'error');
      }));
    }
    else {
      (await this.onbaseService.updateOnBaseRequest(this.request.code, requestData, isDraft, this.biometryForm.get('biometryLogCode')?.value).toPromise().then(async x => {
        await this.successSendCreditRequest(requestData, x, isDraft);
      }).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito ${this.request.code}`, `Error al querer modificar la solicitud ${error}`, undefined, 'error');
      }));
    }

  }

  private async successSendCreditRequest(requestData: CreditRequestData, x: ResponseModel<CreditRequest>, isDraft: boolean) {
    if (this.generalnformationForm.value.requestType == "AVAL") {
      await this.onbaseService.updateBankGuarantee(requestData.Codigo_Solicitud_Principal, x.response.code).toPromise();
    }
    await this.sendDocuments(isDraft, x);
    this.router.navigate(["creditRequests", x.response.code]);
  }

  private async sendDocuments(isDraft: boolean, x: ResponseModel<CreditRequest>) {
    if (!isDraft) {
      if (!x.response.code) {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `Hubo un error al querer crear la solicitud de crédito: ${x.response}`);
        return;
      }
      await this.onbaseService.sendDocuments(x.response.code, this.customer.mainPersonalInfo?.fiscalId || "", this.documentsForm).catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `La solicitud con código ${x.response.code} se ha creado pero hubo un error al querer guardar los documentos`)
        this.router.navigate(["creditRequests", x.response.code]);
      });
      Swal.fire({
        title: `Solicitudes de Crédito`,
        text: `La solicitud con código ${x.response.code} se ha creado con éxito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }
    else {
      await (await this.onbaseService.sendDocumentsDraft(x.response.code, this.customer.mainPersonalInfo?.fiscalId || "", this.documentsForm)).toPromise().catch((error: HttpErrorResponse) => {
        this.exceptionSolutionService.showAlertWithSolution(`Solicitudes de Crédito`, `La solicitud con código ${x.response.code} se ha creado en borradores pero hubo un error al querer guardar los documentos`)
        this.router.navigate(["creditRequests", x.response.code]);
      });
      Swal.fire({
        title: `Solicitudes de Crédito`,
        text: `La solicitud con código ${x.response.code} se ha creado en borradores`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  async buildRequest(requestData: CreditRequestData, isDraft: boolean) {
    if (!isDraft) {
      await this.buildRequestCreate(requestData);
    }
    else {
      this.buildRequestDraft(requestData);
    }
  }

  buildRequestDraft(requestData: CreditRequestData) {
    requestData.Tipo_Solicitante = this.generalnformationForm.value.requestType;
    requestData.Tramite = this.generalnformationForm.getRawValue().creditPlanDescription;
    requestData.Vendedor = this.generalnformationForm.getRawValue().sellerCode;
    requestData.Nombre = this.generalnformationForm.getRawValue().sellerName;
    requestData.Observaciones_Ventas = this.observationForm.value.observationText;
    requestData.Origen = "TIENDA";
    requestData.ID_Causa = CreditRequestUtils.getIdCause(this.customerCreditConditions.estadoCliente);
    requestData.Monto_Sugerido_Credito = this.creditPlan.credit.toString();
    requestData.Monto_Aprobado = "0";
    requestData.ID_TipoIdentificacion = this.personInformationForm.getRawValue().fiscalIdType;
    requestData.ReglaLimite = this.creditPlan.limitRule;
    requestData.Nacionalidad = this.customer.mainPersonalInfo?.nationality || "";
    requestData.Identificacion = this.personInformationForm.getRawValue().fiscalId;
    requestData.Tipo_Identificacion = this.personInformationForm.getRawValue().fiscalIdName;
    requestData.Sexo = this.personInformationForm.getRawValue().sex;
    requestData.Primer_Nombre = this.customerInfoFromSAP.personaNatural.firstName;
    requestData.Segundo_Nombre = this.customerInfoFromSAP.personaNatural.middleName;
    requestData.Primer_Apellido = this.customerInfoFromSAP.personaNatural.lastName;
    requestData.Segundo_Apellido = this.customerInfoFromSAP.personaNatural.lastName2;
    requestData.Fecha_Nacimiento = this.datePipe.transform(this.personInformationForm.getRawValue().birthDate, FULL_DATE_PATTERN) || "";
    requestData.Edad = this.personInformationForm.getRawValue().age;
    requestData.Estado_Civil = this.personInformationForm.getRawValue().civilStatus;
    requestData.Numero_Dependientes = this.personInformationForm.getRawValue().dependentsAmount;
    requestData.Correo_Electronico = this.personInformationForm.getRawValue().email;
    requestData.Vehiculo = this.personInformationForm.getRawValue().vehicle ? "SI" : "NO";
    requestData.Ocupacion = this.personInformationForm.getRawValue().ocupation;
    requestData.Titulo_Academico = this.personInformationForm.getRawValue().academicTitle;
    requestData.Tipo_Vivienda = this.personAddressInformationForm.value.homeType;
    requestData.Pais = this.personAddressInformationForm.value.country;
    requestData.Departamento = this.personAddressInformationForm.value.deparment;
    requestData.Ciudad_Municipio = this.personAddressInformationForm.value.city;
    requestData.Aldea_Barrio_Caserio_Colonia = this.personAddressInformationForm.value.neighborhood;
    requestData.Calle1 = this.personAddressInformationForm.value.street;
    requestData.Calle2 = this.personAddressInformationForm.value.street2;
    requestData.Calle3 = this.personAddressInformationForm.value.street3;
    requestData.Calle4 = this.personAddressInformationForm.value.street4;
    requestData.Calle5 = this.personAddressInformationForm.value.street5;
    requestData.Vive_Desde = this.datePipe.transform(this.personAddressInformationForm.value.liveFromDate, FULL_DATE_PATTERN) || "";
    requestData.Celular = this.personAddressInformationForm.value.mobilePhone;
    requestData.Telefono = this.personAddressInformationForm.value.phone;
    requestData.Fuente_Ingreso = this.personIncomeInformationForm.value.incomeType;
    requestData.ListaReferencias = this.personReferencesInformationform.controls.map(m => {
      m.enable();
      let result = new CreditReferenceList();
      result.DR_Celular = m.value.mobilePhone;
      result.DR_Parentesco = m.value.familyRelationship;
      result.DR_Primer_Nombre = m.value.firstName;
      result.DR_Segundo_Nombre = m.value.middleName;
      result.DR_Primer_Apellido = m.value.lastName;
      result.DR_Segundo_Apellido = m.value.secondLastName;
      result.DR_Telefono = m.value.phone
      result.DR_Telefono_Trabajo = m.value.workPhone;
      result.DR_Telefono_Trabajo_Extension = m.value.workPhoneExtension;
      result.objIdReferencia = "0"
      result.valid = m.valid;
      return result;
    })
    requestData.Codigo_Cliente_BP = this.customer.code;
    requestData.Codigo_Solicitud_Principal = this.bankRepresentativeForm.value.mainRequestCode;
    requestData.Division = this.configService.readSelectedBranchAndSalesOrg().branch.name;
    requestData.Empresa = this.configService.readSelectedBranchAndSalesOrg().salesOrg.name;
    requestData.Tipo_Cliente = "NATURAL";
    requestData.Segmento = "HN_001";
    requestData.ID_Tipo_Tramite = this.creditPlan.code;
    switch (this.personIncomeInformationForm.value.incomeType) {
      case "Z000":
        this.buildSalariedRequestDraft(requestData);
        break;
      case "Z001":
        this.buildIndependentRequestDraft(requestData);
        break;
      case "Z002":
        this.buildRemittanceRequestDraft(requestData);
        break;
      case "Z005":
        this.buildOtherIncomesRequestDraft(requestData);
        break;
      default:
        break;
    }
  }

  buildSalariedRequestDraft(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Tipo_Empresa = values.companyType
    requestData.Nombre_Lugar_Trabajo = values.companyName;
    requestData.Salario_Mensual = values.monthlySalaryAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.startDate, FULL_DATE_PATTERN) || "";
    requestData.Tipo_Contrato = values.workContractType;
    requestData.Departamento_Labora = values.workDepartmentName
    requestData.Cargo = values.workPosition
    requestData.Ingreso = values.monthlySalaryAmount;
    requestData.Pais_Trabajo = values.country;
    requestData.Departamento_Empresa = values.deparment;
    requestData.Ciudad_Municipio_Empresa = values.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = values.neighborhood;
    requestData.Calle1_Empresa = values.street;
    requestData.Calle2_Empresa = values.street2;
    requestData.Calle3_Empresa = values.street3;
    requestData.Calle4_Empresa = values.street4;
    requestData.Calle5_Empresa = values.street5;
    requestData.Telefono_Empresa = values.companyPhone;
    requestData.Extension_Telefono_Empresa = values.companyExtension;
  }

  buildIndependentRequestDraft(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.businessRelationDate, FULL_DATE_PATTERN) || "";
    requestData.Actividad_Economica = values.economicActivity;
    requestData.Relacion_Empresa = values.businessRelationType;
    requestData.Nombre_Negocio = values.businessName;
    requestData.Pais_Trabajo = values.country;
    requestData.Departamento_Empresa = values.deparment;
    requestData.Ciudad_Municipio_Empresa = values.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = values.neighborhood;
    requestData.Calle1_Empresa = values.street;
    requestData.Calle2_Empresa = values.street2;
    requestData.Calle3_Empresa = values.street3;
    requestData.Calle4_Empresa = values.street4;
    requestData.Calle5_Empresa = values.street5;
    requestData.Telefono_Empresa = values.companyPhone;
    requestData.Extension_Telefono_Empresa = values.companyExtension;
  }

  buildRemittanceRequestDraft(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.receivingDate, FULL_DATE_PATTERN) || "";
    requestData.Nombre_Remitente = values.remittanceName;
    requestData.Parentesco = values.familyRelationship;
    requestData.Procedencia = values.incomeOrigin;
  }

  buildOtherIncomesRequestDraft(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.receivingDate, FULL_DATE_PATTERN) || "";
    requestData.Tipo_Ingreso = values.incomeType;
    requestData.Especifique = values.specify;
  }

  async buildRequestCreate(requestData: CreditRequestData) {
    requestData.Tipo_Solicitante = this.generalnformationForm.value.requestType == "AVAL" ? await this.getEndorsementType() : "CLIENTE";
    requestData.Tramite = this.generalnformationForm.getRawValue().creditPlanDescription;
    requestData.Vendedor = this.generalnformationForm.getRawValue().sellerCode;
    requestData.Nombre = this.generalnformationForm.getRawValue().sellerName;
    requestData.Observaciones_Ventas = this.observationForm.value.observationText;
    requestData.Origen = "TIENDA";
    requestData.ID_Causa = CreditRequestUtils.getIdCause(this.customerCreditConditions.estadoCliente);
    requestData.Monto_Sugerido_Credito = this.creditPlan.credit.toString();
    requestData.ID_TipoIdentificacion = this.personInformationForm.getRawValue().fiscalIdType;
    requestData.ReglaLimite = this.creditPlan.limitRule;
    requestData.Nacionalidad = this.nationalities.find(f => f.code == this.customer.mainPersonalInfo?.nationality)?.name || this.customer.mainPersonalInfo?.nationality || "";
    requestData.Identificacion = this.personInformationForm.getRawValue().fiscalId;
    requestData.Tipo_Identificacion = this.personInformationForm.getRawValue().fiscalIdName;
    requestData.Sexo = this.personInformationForm.getRawValue().sex;
    requestData.Primer_Nombre = this.customerInfoFromSAP.personaNatural.firstName;
    requestData.Segundo_Nombre = this.customerInfoFromSAP.personaNatural.middleName;
    requestData.Primer_Apellido = this.customerInfoFromSAP.personaNatural.lastName;
    requestData.Segundo_Apellido = this.customerInfoFromSAP.personaNatural.lastName2;
    requestData.Fecha_Nacimiento = this.datePipe.transform(this.personInformationForm.getRawValue().birthDate, FULL_DATE_PATTERN) || "";
    requestData.Edad = this.personInformationForm.getRawValue().age;
    requestData.Estado_Civil = this.personInformationForm.getRawValue().civilStatus;
    requestData.Numero_Dependientes = this.personInformationForm.getRawValue().dependentsAmount;
    requestData.Correo_Electronico = this.personInformationForm.getRawValue().email;
    requestData.Vehiculo = this.personInformationForm.getRawValue().vehicle ? "SI" : "NO";
    requestData.Ocupacion = this.onbaseCatalogue.occupation[this.personInformationForm.getRawValue().ocupation];
    requestData.Titulo_Academico = this.onbaseCatalogue.academicTitle[this.personInformationForm.getRawValue().academicTitle];
    requestData.Tipo_Vivienda = this.onbaseCatalogue.homeType[this.personAddressInformationForm.value.homeType];
    requestData.Pais = this.nationalities.find(f => f.code == this.personAddressInformationForm.value.country)?.country || "";
    requestData.Departamento = (await this.regionService.readRegions(this.personAddressInformationForm.value.country, this.personAddressInformationForm.value.deparment).toPromise()).response.content[0].name;
    requestData.Ciudad_Municipio = (await this.cityService.readCities(this.personAddressInformationForm.value.country, this.personAddressInformationForm.value.deparment).toPromise()).response.content.find(f => f.cityCode == this.personAddressInformationForm.value.city)?.name || this.personAddressInformationForm.value.city;
    requestData.Calle1 = this.personAddressInformationForm.value.street;
    requestData.Calle2 = this.personAddressInformationForm.value.street2;
    requestData.Calle3 = this.personAddressInformationForm.value.street3;
    requestData.Calle4 = this.personAddressInformationForm.value.street4;
    requestData.Calle5 = this.personAddressInformationForm.value.street5;
    requestData.Aldea_Barrio_Caserio_Colonia = (await this.colonyService.readColonies(this.personAddressInformationForm.value.city).toPromise()).response.content.find(f => f.code == this.personAddressInformationForm.value.neighborhood)?.name || this.personAddressInformationForm.value.neighborhood;
    requestData.Vive_Desde = this.datePipe.transform(this.personAddressInformationForm.value.liveFromDate, FULL_DATE_PATTERN) || "";
    requestData.Celular = this.personAddressInformationForm.value.mobilePhone;
    requestData.Telefono = this.personAddressInformationForm.value.phone;
    requestData.Fuente_Ingreso = CreditRequestUtils.getIncomeType(this.personIncomeInformationForm.value.incomeType).description;
    requestData.ListaReferencias = this.personReferencesInformationform.controls.map(m => {
      m.enable();
      let result = new CreditReferenceList();
      result.DR_Celular = m.value.mobilePhone;
      result.DR_Parentesco = this.onbaseCatalogue.naturalRelation[m.value.familyRelationship];
      result.DR_Primer_Nombre = m.value.firstName;
      result.DR_Segundo_Nombre = m.value.middleName;
      result.DR_Primer_Apellido = m.value.lastName;
      result.DR_Segundo_Apellido = m.value.secondLastName;
      result.DR_Telefono = m.value.phone
      result.DR_Telefono_Trabajo = m.value.workPhone;
      result.DR_Telefono_Trabajo_Extension = m.value.workPhoneExtension;
      result.objIdReferencia = "0"
      result.valid = m.valid;
      return result;
    })
    requestData.Codigo_Cliente_BP = this.customer.code;
    requestData.Codigo_Solicitud_Principal = this.bankRepresentativeForm.value.mainRequestCode;
    requestData.Division = this.configService.readSelectedBranchAndSalesOrg().branch.name;
    requestData.Empresa = this.configService.readSelectedBranchAndSalesOrg().salesOrg.name;
    requestData.Monto_Aprobado = "0";
    requestData.Tipo_Cliente = "NATURAL";
    requestData.Segmento = "HN_001";
    requestData.ID_Tipo_Tramite = this.creditPlan.code;
    switch (this.personIncomeInformationForm.value.incomeType) {
      case "Z000":
        await this.buildSalariedRequest(requestData);
        break;
      case "Z001":
        await this.buildIndependentRequest(requestData);
        break;
      case "Z002":
        await this.buildRemittanceRequest(requestData);
        break;
      case "Z005":
        await this.buildOtherIncomesRequest(requestData);
        break;
      default:
        break;
    }

  }
  buildOtherIncomesRequest(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.receivingDate, FULL_DATE_PATTERN) || "";
    requestData.Tipo_Ingreso = otherIncomeTypes.find(f => f.key == values.incomeType)?.value || "";
    requestData.Especifique = values.specify;
  }

  async buildRemittanceRequest(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.receivingDate, FULL_DATE_PATTERN) || "";
    requestData.Nombre_Remitente = values.remittanceName;
    requestData.Parentesco = this.onbaseCatalogue.naturalRelation[values.familyRelationship];
    requestData.Procedencia = incomeOrigins.find(f => f.key == values.incomeOrigin)?.value || "";
  }

  async buildIndependentRequest(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Salario_Mensual = values.incomeAmount;
    requestData.Ingreso = values.incomeAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.businessRelationDate, FULL_DATE_PATTERN) || "";
    requestData.Actividad_Economica = this.onbaseCatalogue.economicActivity.find(f => f.key == values.economicActivity)?.description || "";
    requestData.Relacion_Empresa = this.onbaseCatalogue.relationType[values.businessRelationType];
    requestData.Nombre_Negocio = values.businessName;
    requestData.Pais_Trabajo = this.nationalities.find(f => f.code == values.country)?.country || "";
    requestData.Departamento_Empresa = (await this.regionService.readRegions(values.country, values.deparment).toPromise()).response.content[0].name;
    requestData.Ciudad_Municipio_Empresa = (await this.cityService.readCities(values.country, values.deparment).toPromise()).response.content.find(f => f.cityCode == values.city)?.name || values.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = (await this.colonyService.readColonies(values.city).toPromise()).response.content.find(f => f.code == values.neighborhood)?.name || values.neighborhood;
    requestData.Calle1_Empresa = values.street;
    requestData.Calle2_Empresa = values.street2;
    requestData.Calle3_Empresa = values.street3;
    requestData.Calle4_Empresa = values.street4;
    requestData.Calle5_Empresa = values.street5;
    requestData.Telefono_Empresa = values.companyPhone;
    requestData.Extension_Telefono_Empresa = values.companyExtension;
  }

  async buildSalariedRequest(requestData: CreditRequestData) {
    let values = this.personIncomeInformationForm.value.incomeForm;
    requestData.Tipo_Empresa = this.onbaseCatalogue.business[values.companyType]
    requestData.Nombre_Lugar_Trabajo = values.companyName;
    requestData.Salario_Mensual = values.monthlySalaryAmount;
    requestData.Fecha_Ingreso_Empresa = this.datePipe.transform(values.startDate, FULL_DATE_PATTERN) || "";
    requestData.Tipo_Contrato = this.onbaseCatalogue.loanType[values.workContractType];
    requestData.Departamento_Labora = values.workDepartmentName
    requestData.Cargo = values.workPosition
    requestData.Ingreso = values.monthlySalaryAmount;
    requestData.Pais_Trabajo = this.nationalities.find(f => f.code == values.country)?.country || "";
    requestData.Departamento_Empresa = (await this.regionService.readRegions(values.country, values.deparment).toPromise()).response.content[0].name;
    requestData.Ciudad_Municipio_Empresa = (await this.cityService.readCities(values.country, values.deparment).toPromise()).response.content.find(f => f.cityCode == values.city)?.name || values.city;
    requestData.Aldea_Barrio_Caserio_Colonia_Empresa = (await this.colonyService.readColonies(values.city).toPromise()).response.content.find(f => f.code == values.neighborhood)?.name || values.neighborhood;
    requestData.Calle1_Empresa = values.street;
    requestData.Calle2_Empresa = values.street2;
    requestData.Calle3_Empresa = values.street3;
    requestData.Calle4_Empresa = values.street4;
    requestData.Calle5_Empresa = values.street5;
    requestData.Telefono_Empresa = values.companyPhone;
    requestData.Extension_Telefono_Empresa = values.companyExtension;
  }

  showRepresentativeStep() {
    return this.generalnformationForm.value.requestType == "AVAL";
  }

  goToStep(step: string) {

    this.selectedIndex = this.getStepMap(step);
  }

  getStepMap(step: string) {
    let stepMap = new Map<string, number>();
    let index = 0;
    stepMap.set("generalnformationForm", index++);
    if (this.showRepresentativeStep()) {
      stepMap.set("bankRepresentativeForm", index++);
    }
    stepMap.set("personInformationForm", index++);
    stepMap.set("personAddressInformationForm", index++);
    stepMap.set("personIncomeInformationForm", index++);
    stepMap.set("personReferencesInformationform", index++);
    stepMap.set("observationForm", index++)
    stepMap.set("documentsForm", index++);
    if (step == `biometryValidationForm`) {
      return this.stepper.steps.length - 1;
    }
    return stepMap.get(step) || 0;
  }

  canShowBiometryStep(): boolean {
    return !this.verifyIfNotNeedBiometryValidation();
  }

  private verifyIfNotNeedBiometryValidation() {
    return this.listOfBranchesNotValidateBiometry.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code);
  }

  async handleCreateCreditRequestFromBiometryValidation(biometryLogCode: string): Promise<void> {
    if (biometryLogCode != '') {
      this.biometryForm.patchValue({ biometryLogCode: biometryLogCode });
    }
  }

  handlePictureTaken(pictureUrlString: string) {
    this.pictureUrlString = pictureUrlString;
  }

  isSomeFormInvalid() {
    return this.generalnformationForm.invalid ||
      (this.showRepresentativeStep() && this.bankRepresentativeForm.invalid) ||
      this.personInformationForm.invalid ||
      this.personAddressInformationForm.invalid ||
      this.personIncomeInformationForm.invalid ||
      this.personReferencesInformationform.invalid ||
      this.observationForm.invalid ||
      this.documentsForm.invalid;
  }

  async getEndorsementType(): Promise<string> {
    const creditRequest = (await this.onbaseService.readOnbaseRequestByCode(this.bankRepresentativeForm.value.mainRequestCode).toPromise()).response;
    return creditRequest.customer.mainPersonalInfo.personality == Personality.LEGAL_ENTITY ? "REPRESENTANTE" : "AVAL";
  }

  handleRequestTypeChange(requestType: string) {
    this.requestType = requestType;
  }

  configureBiometryForm() {
    if (this.canShowBiometryStep()) {
      this.biometryForm = new FormGroup({
        'biometryLogCode': new FormControl('', Validators.required)
      });
      this.biometryForm.markAsTouched();
      this.biometryForm.markAsDirty();
    }
  }

  async configureBiometryFormFromRequest() {
    if (this.canShowBiometryStep()) {
      if (this.request.biometryLogCode != undefined && this.request.biometryLogCode != '') {
        const biometryLogResponse = (await this.biometryService.getBiometryLog({ value: { code: this.request.biometryLogCode }, page: 0, pageSize: 10 }).toPromise()).response;
        this.biometryLog = biometryLogResponse.content[0];
        this.biometryForm = new FormGroup({
          'biometryLogCode': new FormControl(this.request.biometryLogCode || '', Validators.required),
        });
      }
      this.biometryForm.markAsTouched();
      this.biometryForm.markAsDirty();
    }
  }

  isShortFormActiveForPlan(): boolean {
    return this.shortFormCreditPlanCodes.includes(this.creditPlan.code);
  }

  async createDrafRequest() {
    let requestData = new CreditRequestData();
    let createOnbaseRequestResponse;

    await this.buildRequest(requestData, true);

    try {
      createOnbaseRequestResponse = await this.onbaseService.createOnBaseRequest(requestData, true).toPromise();
    } catch (error) {
      Swal.fire({
        title: '¡Advertencia!',
        text: `Sucedio un problema en la creacion de la solicitud de credito en borradores`,
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    this.request = createOnbaseRequestResponse.response;

    if (this.generalnformationForm.value.requestType == "AVAL") {
      await this.onbaseService.updateBankGuarantee(requestData.Codigo_Solicitud_Principal, createOnbaseRequestResponse.response.code).toPromise();
    }

    try {
      await this.onbaseService.sendDocumentsDraft(createOnbaseRequestResponse.response.code, this.customer.mainPersonalInfo?.fiscalId || "", this.documentsForm);
    } catch (error) {
      Swal.fire({
        title: '¡Advertencia!',
        text: `La solicitud con código ${createOnbaseRequestResponse.response.code} se ha creado en borradores pero hubo un error al querer guardar los documentos`,
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
    }

    // TODO: Revisar si esta es la mejor forma de marcar como creada la solicitud.
    this.request = createOnbaseRequestResponse.response;
    this.isDraft = true;

  }

  handlePictureTakenFromBiometry(pictureUrl: string) {
    this.setFileByDescription(ID_SECOND_IDENTICATION_GROUP_DOCUMENT, nameOfDocumentToTakePictureOnCreditRequests, pictureUrl);
  }

  setFileByDescription(id: string, descriptionToFind: string, pictureUrl: string) {
    const group = this.documentsForm.controls.find(
      (ctrl: AbstractControl) => ctrl.get('id')?.value === id
    ) as FormGroup | undefined;

    if (!group) {
      return;
    }

    const documentsArray = group.get('documents') as FormArray;

    if (!documentsArray) {
      return;
    }

    const foundIndex = (documentsArray.controls as FormGroup[]).findIndex(docGroup => {
      const descKey = Object.keys(docGroup.controls).find(k => k.startsWith('description_'));
      const descValue = descKey ? docGroup.get(descKey)?.value?.toLowerCase() : '';
      return descValue.includes(descriptionToFind.toLowerCase());
    });

    if (foundIndex === -1) {
      return;
    }

    const docGroup = documentsArray.at(foundIndex) as FormGroup;

    const fileNameKey = `document_fileName_${id}_${foundIndex}`;
    const fileKey = `document_${id}_${foundIndex}`;
    const extKey = `document_ext_${id}_${foundIndex}`;
    const typeKey = `document_documentType_${id}_${foundIndex}`;

    const pictureFile = FileUtils.dataURLtoFile(pictureUrl || '', `document_fileName_${id}_${foundIndex}`);

    if (!pictureFile) {
      return;
    }

    const fileType = this.onbaseService.getFileType(`${pictureFile?.name}.jpg`)

    docGroup.patchValue({
      [fileKey]: pictureFile,
      [fileNameKey]: pictureFile.name,
      [extKey]: fileType.ext,
      [typeKey]: fileType.code,
    });

    docGroup.markAsDirty();
    docGroup.updateValueAndValidity();
  }
}
